<div class="bmc-user-group-specific-user">
    <div class="bmc-user-group-specific-user__basic-data-container bz-space--stack-l">
        <div class="bmc-user-group-specific-user__select-item bz-space--inline-s">
            <strong>{{'USER_GROUPS_BY_USER.SEARCH_USER_BY' | translate}}</strong>
            <bzg-select [placeholder]="'USER_GROUPS_BY_USER.SELECT_A_CATEGORY' | translate" [(value)]="selectedFilterColumn">
                <bzg-option  *ngFor="let filterColumn of (filterColumns$ | async)" [value]="filterColumn">{{ filterColumnsResources[filterColumn] | translate }}</bzg-option>
            </bzg-select>
        </div>
        <div class="bmc-user-group-specific-user__select-item">
            <strong>{{'USER_GROUPS_BY_USER.SEARCH_AN_USER_TO_ADD' | translate}}</strong>
            <bzg-autocomplete [placeholder]="'USER_GROUPS_BY_USER.SEARCH_USER' | translate" [optionSize]="'medium'"
                (valueChange)="filter($event)" (optionSelected)="userSelected($event)" [displayWith]="displayFn">
                <bzg-option *ngFor="let userAutocomplete of (autocompleteUsers$ | async)" [value]="userAutocomplete">
                    <ng-container *ngIf="!(isLoadingUsers$ | async)  && (autocompleteUsers$ | async).length > 0">
                        <div class="bz-initials bz-space--inline-s">{{ userAutocomplete.fullName.trim().charAt(0).toUpperCase() }}
                        </div>
                        <div class="bz-option__info">
                            <span class="bz-option__title">{{ userAutocomplete.fullName }}</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!(isLoadingUsers$ | async) && (autocompleteUsers$ | async).length === 0">
                        <div class="bz-option__info">
                            <span class="bz-option__title">{{ 'USER_GROUPS.FILTER_NO_RESULTS' | translate }}</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="(isLoadingUsers$ | async)">
                        <div class="bz-option__info">
                            <span class="bz-option__title">{{ 'USER_GROUPS.FILTER_USERS_LOADING' | translate }}</span>
                        </div>
                    </ng-container>
                </bzg-option>
            </bzg-autocomplete>
        </div>

    </div>
    <div class="bmc-user-group-specific-user__content-table">
            <table class="bz-table">
                    <thead>
                        <tr>
                            <th class="bz-table__cell bz-table__cell--sortable bmc-user-group-specific-user__cell-left">
                                {{'USER_GROUPS_BY_USER.COLUMN_USERNAME' | translate}}
                            </th>
                            <th class="bz-table__cell bz-table__cell--sortable">
                                {{'USER_GROUPS_BY_USER.COLUMN_INCLUDE' | translate}}
                            </th>
                            <th class="bz-table__cell bz-table__cell--sortable">
                                {{'USER_GROUPS_BY_USER.COLUMN_EXCLUDE' | translate}}
                            </th>
                            <th class="bz-table__cell bz-table__cell--sortable">
                                {{'USER_GROUPS_BY_USER.COLUMN_DELETE' | translate}}
                            </th>
            
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let currentUser of (users$ | async)">
                            <td class="bz-table__cell">
                                <div class="bmc-user-group-specific-user__avatar-container">
                                    <div class="bz-initials bz-space--inline-s">
                                        {{ currentUser.userName.trim().charAt(0).toUpperCase() }}
                                    </div>
                                    {{ currentUser.userName }}
                                </div>
                            </td>
                            <td class="bz-table__cell">
                                <bzg-radio-button [checked]="currentUser.include" (change)="modifyStatus('include', currentUser)"></bzg-radio-button>
                            </td>
                            <td class="bz-table__cell">
                                <bzg-radio-button [checked]="!currentUser.include" (change)="modifyStatus('exclude', currentUser)"></bzg-radio-button>
                            </td>
                            <td class="bz-table__cell">
                                <bzg-icon [nameIcon]="'icon-delete'" (click)="deleteUserFromTable(currentUser.id)"></bzg-icon>
                            </td>
                        </tr>
                    </tbody>
                </table>
    </div>

</div>